;(function(global, $) {
  /* @if env='production' **
  var MALL_SERVER = 'https://api-material.huariot.com/api-mall/api/v1'
  var BASE_SERVER = 'https://api-material.huariot.com/api-base/api/v1'
  var USER_SERVER = 'https://api-material.huariot.com/api-user/api/v1'
  /* @endif */
  /* @if env='testing' **
  var MALL_SERVER = 'http://test.portal.huariot.com/api-mall/api/v1'
  var BASE_SERVER = 'http://test.portal.huariot.com/api-base/api/v1'
  var USER_SERVER = 'http://test.portal.huariot.com/api-user/api/v1'
  /* @endif */
  /* @if env='development' **
  var MALL_SERVER = '/api-mall/api/v1'
  var BASE_SERVER = '/api-base/api/v1'
  var USER_SERVER = '/api-user/api/v1'
  /* @endif */

  var AreaKey = 'HwMallArea'

  // 获取省份
  function getProvince(callback) {
    return Fetch({
      url: BASE_SERVER + '/province/list/',
      type: 'GET'
    }, callback)
  }

  // 获取指定省份的市列表
  function getCity(id, callback) {
    return Fetch({
      url: BASE_SERVER + '/province/'+ id +'/city/list/',
      type: 'GET'
    }, callback)
  }

  // 获取指定市的县区列表
  function getCountry(id, callback) {
    return Fetch({
      url: BASE_SERVER + '/province/'+ id +'/county/list/',
      type: 'GET'
    }, callback)
  }

  // 获取区域树形结构
  function getArea(callback) {
    return Fetch({
      url: `${MALL_SERVER}/mall/region-tree/`
    }, callback)
  }

  //设置区域缓存进入localStorage
  function setAreatoSession(data) {
    window.localStorage.setItem(AreaKey, JSON.stringify(data))
  }
  
  //获取区域缓存
  function getAreafromSession() {
    var areas = window.localStorage.getItem(AreaKey)
    return !areas ? '' : JSON.parse(areas)
  }

  // 修改密码
  function editPwd(condition, callback) {
    return Fetch({
      url: USER_SERVER + '/user/password/',
      type: 'PUT',
      data: JSON.stringify(condition)
    }, callback)
  }

  
  global['BASE'] = {
    getArea,
    setAreatoSession,
    getAreafromSession,
    getProvince,
    getCity,
    getCountry
  }
  
  global['USER'] = {
    editPwd
  }
}(window, window.jQuery))
